import { styled } from '@mui/material';
import { useMemo } from 'react';

export type WorkspaceAvatarProps = {
  title: string;
};

const StyledAvatar = styled('div')<{ stopColor: number; startColor: number }>(
  ({ startColor, stopColor, theme }) => ({
    borderRadius: 4,
    fontWeight: 500,
    flex: '0 0 auto',
    height: theme.spacing(6),
    width: theme.spacing(6),
    fontSize: 10,
    marginRight: 8,
    color: '#fff',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: `linear-gradient(165deg, hsl(${startColor},100%,40%,1) 0%, hsl(${stopColor},100%,40%,1) 100%)`,
  })
);

export const WorkspaceAvatar = ({ title }: WorkspaceAvatarProps) => {
  const [startColor, stopColor] = useMemo(() => {
    const value = Array.from(title).reduce(
      (acc, curr) => (acc + curr.charCodeAt(0)) % 360,
      0
    );

    return [value, (value + 60) % 360];
  }, [title]);

  return (
    <StyledAvatar startColor={startColor} stopColor={stopColor}>
      {title[0].toUpperCase()}
    </StyledAvatar>
  );
};
